import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

const FullScreenLoader = () => (
    <div className="min-h-screen bg-[var(--sb-page)] text-white flex items-center justify-center">
        <div className="text-xs uppercase tracking-ultra-wide text-zinc-500 inline-flex items-center gap-3">
            <span className="kpi-pip animate-pulse" style={{ background: "var(--sb-amber)" }} />
            floodlights warming up
        </div>
    </div>
);

export const Protected = ({ children, roles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading || user === undefined) return <FullScreenLoader />;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (roles && !roles.includes(user.role)) {
        // Send users to their natural home if they hit the wrong area
        const home = user.role === "platform_owner" ? "/platform" : user.role === "club_admin" ? "/club" : "/sponsor";
        return <Navigate to={home} replace />;
    }
    return children;
};

export const RoleHome = () => {
    const { user, loading } = useAuth();
    if (loading || user === undefined) return <FullScreenLoader />;
    if (!user) return <Navigate to="/login" replace />;
    if (user.role === "platform_owner") return <Navigate to="/platform" replace />;
    if (user.role === "club_admin") return <Navigate to="/club" replace />;
    if (user.role === "sponsor") return <Navigate to="/sponsor" replace />;
    return <Navigate to="/login" replace />;
};
